import { CourseOutlinePayload, Module, QuizModule } from '../types';

export const getQuizModulesFromOutline = (
  generatedOutline: any
): QuizModule[] => {
  if (!generatedOutline?.modules) return [];

  return generatedOutline.modules
    .filter((module: any) => module.type === 'quiz')
    .map((module: any) => ({
      title: module.name,
      type: 'quiz' as const,
      duration: `${module.duration}m`,
      maxPoints: module.maxPoints || 100,
      screens: module.screens.map((screen: any) => ({
        title: screen.title,
        question: {
          text: screen.question?.text || screen.title,
          points: screen.question?.points || 1,
          options: screen.question?.options || [
            { text: 'Option 1', correct: true },
            { text: 'Option 2', correct: false },
          ],
          hint: screen.question?.hint || '',
        },
      })),
    }));
};

export const createCourseOutlinePayload = (
  courseTitle: string,
  courseDescription: string,
  modules: Module[],
  quizModules: QuizModule[],
  formValues: any,
): CourseOutlinePayload => {
  return {
    name: courseTitle,
    description: courseDescription,
    modules: [
      // Add content modules from current state
      ...modules.map((module) => ({
        name: module.title,
        type: 'content' as const,
        duration: parseInt(module.duration.replace('m', '')) || 10,
        screens: module.lessons.map((lesson) => ({
          title: lesson.title,
          contentPoints: lesson.objectives || [],
        })),
      })),
      // Add quiz modules with current form data
      ...quizModules.map((quiz, quizIndex) => ({
        name: quiz.title,
        type: 'quiz' as const,
        duration: parseInt(quiz.duration.replace('m', '')) || 8,
        maxPoints: quiz.maxPoints,
        screens: quiz.screens.map((screen, screenIndex) => {
          // Get current form values for this screen from flat structure
          const questionText =
            formValues[`questionText_${quizIndex}_${screenIndex}`] ||
            screen.question.text;
          const options =
            formValues[`options_${quizIndex}_${screenIndex}`] ||
            screen.question.options;
          const points =
            formValues[`points_${quizIndex}_${screenIndex}`] ||
            screen.question.points;
          const hint =
            formValues[`hint_${quizIndex}_${screenIndex}`] ||
            screen.question.hint;

          // Filter out temporary ID fields from options
          const cleanOptions = options.map((option: any) => ({
            text: option.text,
            correct: option.correct,
          }));

          return {
            title: screen.title,
            contentPoints: [],
            question: {
              text: questionText,
              points,
              options: cleanOptions,
              hint: hint || '',
            },
          };
        }),
      })),
    ],
  };
};
